export default /^[a-z\d](?:[a-z\d]|-(?=[a-z\d])){0,38}$/i;
